// projectsData.js
import after1 from '../../assets/projects/p1/p1.jpeg';
import after2 from '../../assets/projects/p1/p2.jpeg';
import after3 from '../../assets/projects/p1/p3.jpeg';
import after4 from '../../assets/projects/p1/p4.jpeg';
import after5 from '../../assets/projects/p1/p5.jpeg';
import before1 from '../../assets/projects/p1/p6.jpeg';
import before2 from '../../assets/projects/p1/p7.jpeg';
import before3 from '../../assets/projects/p1/p8.jpeg';
import before4 from '../../assets/projects/p1/p9.jpeg';
import before5 from '../../assets/projects/p1/p10.jpeg';
import v1 from '../../assets/projects/p1/pv1.mp4';

export const projectsData = [
  {
    id: 1,
    slug: "modern-residential-transformation",
    title: "Modern Residential Transformation",
    type: "Residential",
    location: "New York, NY",
    duration: "6 Months",
  
    description: "Complete home renovation with modern open-concept living space, updated kitchen, and outdoor entertainment area.",
    shortDescription: "Complete home renovation with modern open-concept living",
    beforeImages: [before1, before2, before3, before4, before5],
    afterImages: [after1, after2, after3, after4, after5],
    video: v1,
    features: [
      "Open floor plan",
      "Energy-efficient windows",
      "Smart home integration",
      "Custom kitchen cabinetry",
      "Landscaped backyard"
    ],
    status: "Completed",
    year: "2025",
    area: "2,500 sq ft"
  },
 
];